import { ButtonToggleGroup } from "../wrappers/ButtonToggleGroup";
import { RangeCheckboxGroup } from "../wrappers/RangeCheckboxGroup";

/**
 * Represents an optional map that provides a wrapper component for its corresponding filter option component.
 *
 * E.g. Property Class (star) needs to be wrapped with UitkButtonToggleGroup in order to be rendered in a "row" direction.
 */
export const PROPERTY_FILTERS_COMPONENT_WRAPPER_MAP = {
  star: ButtonToggleGroup,
  price: RangeCheckboxGroup,
};
